<clx-form [save]="execute.bind(this)" has="full-height" [disableChangeChecking]="true">
    <clx-row type="buttons">
        <a is="clx-button"
           href="https://www.lua.org/manual/5.4/manual.html#3"
           target="_blank"
           i18n="@@scripting-editor.help.button"
           test-id="scripting-editor.help.button">Lua help</a>
        <clx-button i18n="@@scripting-editor.globals.button"
                    test-id="scripting-editor.globals.button"
                    (onClick)="showGlobals()">Show globals</clx-button>
        <clx-button [disabled]="getEditorValue() ? null : 'disabled'"
                    i18n="@@scripting-editor.download.button"
                    test-id="scripting-editor.download.button"
                    (onClick)="downloadUcfFile(getEditorValue())">Download UCF file</clx-button>
        <clx-button type="save"
                    i18n="@@scripting-editor.execute.button"
                    test-id="scripting-editor.execute.button">Execute code</clx-button>
        <toggle-button [active]="liveCodeingEnabled"
                       (click)="toggleLiveCoding()"
                       class="small icon fa-refresh fa io"
                       i18n-activeTitle="@@scripting-editor.autoupdate-button.active"
                       activeTitle="auto update active"
                       i18n-inactiveTitle="@@scripting-editor.autoupdate-button.inactive"
                       inactiveTitle="auto update inactive"
                       test-id="scripting-editor.auto-update.button"></toggle-button>
    </clx-row>
    <clx-row has="full-size-columns">
        <clx-item>
            <clx-select name="mode" #scriptType   test-id="scripting-editor.mode.select">
                <clx-value value="singlePlantScheduledAction" [selected]="true">Plant</clx-value>
                <clx-value *ngIf="allowAlarmAndSystemSelection" value="multiplePlantsScheduledAction">System</clx-value>
                <clx-value *ngIf="allowAlarmAndSystemSelection" value="alarmAction">Alarm</clx-value>
            </clx-select>
        </clx-item>
    </clx-row>
    <clx-row *ngIf="scriptType.value === 'singlePlantScheduledAction' || scriptType.value === 'alarmAction'" has="full-size-columns">
        <clx-item>
            <clx-input
                name="plantId"
                #plantIdInput
                (focus)="openPlantSelection()"
                test-id="scripting-editor.plantid.input"
                [returnNullValueIfEmpty]="false"
                [(ngModel)]="plantId"
            >
                <clx-validation type="required"></clx-validation>
            </clx-input>
            <clx-overlay-container
                [opener]="plantIdInput"
                [(open)]="isPlantSelectionOpen"
                [closeOnClickOutside]="true"
                class="datapoint-overlay"
              
            >
                <clx-datapoint-selection
                    show="plant"
                    mode="plant"
                    name="selectPlant"
                    [disableIcon]="true"
                    (selection)="selectPlant($event)"
                    test-id="scripting-editor.plantid.selection"
                    [enableFilter]="true"
                ></clx-datapoint-selection>
            </clx-overlay-container>
        </clx-item>
    </clx-row>
    <clx-row *ngIf="scriptType.value === 'multiplePlantsScheduledAction'" has="full-size-columns">
        <clx-item>
            <clx-input
                name="systemId"
                #plantIdInput
                (focus)="openPlantSelection()"
                test-id="scripting-editor.plantid.input"
                [returnNullValueIfEmpty]="false"
                [(ngModel)]="systemId"
            >
                <clx-validation type="required"></clx-validation>
            </clx-input>
            <clx-overlay-container
                [opener]="plantIdInput"
                [(open)]="isPlantSelectionOpen"
                [closeOnClickOutside]="true"
                class="datapoint-overlay"
              
            >
                <clx-datapoint-selection
                    show="systems"
                    mode="systems"
                    name="selectSystem"
                    [disableIcon]="true"
                    (selection)="selectSystem($event)"
                    test-id="scripting-editor.system.selection"
                    [enableFilter]="true"
                ></clx-datapoint-selection>
            </clx-overlay-container>
        </clx-item>
    </clx-row>
    <clx-row is="script-row" has="full-size-columns">
        <clx-item>
            <clx-item has="seventy-thirty-grid">
                <clx-item>
                    <div #container is="code-container"></div>
                </clx-item>
                <clx-item is="snippet-area">
                    <div i18n="@@scripting-editor.snipplet.topic.snipplet" is="snippet-topic">ClimatixIC Snippets</div>
                    <clx-tag *ngFor="let snippet of snippets | filterByScriptmode:scriptType.value | filterByCategory:'climatix'"
                            [childComponentData]="{ plantInput : plantIdInput }"
                            [childComponent]="snippet"
                            #tag
                            [text]="tag?.componentRef?.instance?.text"
                            (click)="insertSnippet(tag?.componentRef?.instance)"
                            [disableCloseButton]="true"></clx-tag>
                    <div i18n="@@scripting-editor.snipplet.topic.snipplet.common" is="snippet-topic">Common snippets</div>
                    <clx-tag *ngFor="let snippet of snippets | filterByScriptmode:scriptType.value | filterByCategory:'common'"
                            [childComponentData]="{ plantInput : plantIdInput }"
                            [childComponent]="snippet"
                            #tag
                            [text]="tag?.componentRef?.instance?.text"
                            (click)="insertSnippet(tag?.componentRef?.instance)"
                            [disableCloseButton]="true"></clx-tag>
                    <div i18n="@@scripting-editor.snipplet.topic.example" is="snippet-topic">Examples</div>
                    <div i18n="@@scripting-editor.snipplet.topic.exampleinfo" is="snippet-topic" style="font-weight: lighter; padding-top: 0px; font-size: smaller;">Examples will replace the editors content. You can use Ctrl-Z to undo the replacement.</div>
                    <clx-tag *ngFor="let example of examples | filterByScriptmode:scriptType.value"
                            [childComponentData]="{ plantInput : plantIdInput }"
                            [childComponent]="example"
                            #tag
                            [text]="tag?.componentRef?.instance?.text"
                            (click)="insertSnippet(tag?.componentRef?.instance)"
                            [disableCloseButton]="true"></clx-tag>
                    <div i18n="@@scripting-editor.snipplet.topic.advanced.options" is="snippet-topic">Advanced options</div>
                    <div>
                        <clx-row has="full-column-size">
                            <clx-item>
                                <clx-checkbox
                                    name="traceApiCalls"
                                    id="traceApiCalls"
                                    [(value)]="traceApiCalls"
                                ></clx-checkbox>
                                <clx-label i18n="@@scripting-editor.snipplet.topic.trace.api.calls" for="traceApiCalls">Trace API calls</clx-label>
                            </clx-item>
                        </clx-row>
                        <clx-row has="full-column-size">
                            <clx-item>
                                <clx-checkbox
                                    name="addComments"
                                    id="addComments"
                                    [(value)]="addComments"
                                ></clx-checkbox>
                                <clx-label i18n="@@scripting-editor.snipplet.topic.add.comments" for="addComments">Add comments</clx-label>
                            </clx-item>
                        </clx-row>
                        <clx-row has="full-column-size">
                            <clx-item>
                                <clx-checkbox
                                    name="oopMode"
                                    id="oopMode"
                                    [(value)]="oopMode"
                                ></clx-checkbox>
                                <clx-label i18n="@@scripting-editor.snipplet.topic.set.oopmode" for="oopMode">Default OOP mode</clx-label>
                            </clx-item>
                        </clx-row>
                    </div>
                </clx-item>
            </clx-item>
        </clx-item>
    </clx-row>
    <ng-container *ngIf="scriptType.value === 'alarmAction'">
        <clx-row has="full-size-columns">
            <clx-label>Test Alarms</clx-label>
            <clx-item>
                <table is="clx-table" has="borders">
                    <thead>
                        <th i18n="@@scripting-editor.test-data.label.alarm-id">Alarm ID</th>
                        <th i18n="@@scripting-editor.test-data.label.utc-time">Utc Time</th>
                        <th i18n="@@scripting-editor.test-data.label.text">Text</th>
                        <th i18n="@@scripting-editor.test-data.label.event-state" width="100">Event State</th>
                        <th has="icon-button-width centered-aligment">
                            
                        </th>
                    </thead>
                    <clx-repeater
                        name="alarms"
                        #repeater 
                        [disableComponentWrapping]="true" 
                        is="table-body"
                        [(ngModel)]="testAlarms"
                    >
                        <ng-template let-row="row" let-entries="data">
                            <tr  [test-id]="'scripting-editor.test-alarms.row.' + row">
                                <td><clx-input name="alarmId" [test-id]="'scripting-editor.test-alarms.alarm-id.' + row"></clx-input></td>
                                <td><clx-datetime name="utcTime" type="datetime" [value]="defaultDate" [test-id]="'scripting-editor.test-alarms.utc-time.' + row"></clx-datetime></td>
                                <td><clx-input name="alarmString" [test-id]="'scripting-editor.test-alarms.alarm-string.' + row"></clx-input></td>
                                <td>
                                    <clx-select name="eventState" [test-id]="'scripting-editor.test-alarms.event-state.' + row">
                                        <clx-value [value]="0">0</clx-value>
                                        <clx-value [value]="1">1</clx-value>
                                    </clx-select>
                                </td> 
                                <td has="centered-aligment">
                                    <a 
                                        class="icon-link fa fa-remove"
                                        title="Remove entry"
                                        test-id="import-alarm-ids.delete-alarm-id.button"
                                        i18n-title="@@import-alarm-ids.delete-alarm-id.button"
                                        (click)="repeater.deleteEntry(row)"
                                    ></a>
                                </td>
                            </tr>
                        </ng-template>
                    </clx-repeater>
                
                </table>
            </clx-item>

        </clx-row>
        <clx-row type="buttons">
            <clx-button (click)="repeater.addValue({ alarmId: '', alarmString: '', utcTime: defaultDate, eventState : 0})" test-id="scripting-editor.test-alarms.add-value-button">Add Test Alarm</clx-button>
        </clx-row>
    </ng-container>
    <div is="result-area">
        <pre
            is="result-message"
            class="message"
            [class.error]="message.type === 'error'"
            [class.info]="message.type === 'info'"
            [format-text]="{ removeLeadingLinebreak : true}"
            *ngFor="let message of messages"
        >{{message.message}}</pre>
    </div>

</clx-form>
